import { render, staticRenderFns } from "./FileGenerationHistory.vue?vue&type=template&id=0bcd2aa9&scoped=true"
import script from "./FileGenerationHistory.vue?vue&type=script&lang=ts"
export * from "./FileGenerationHistory.vue?vue&type=script&lang=ts"
import style0 from "./FileGenerationHistory.vue?vue&type=style&index=0&id=0bcd2aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd2aa9",
  null
  
)

export default component.exports